<template>
  <VanConfigProvider :theme="appStore.mode" :theme-vars="themeVars" theme-vars-scope="global">
    <div class="app-scroll">
      <router-view v-if="tokenReady" v-slot="{ Component, route }">
        <keep-alive :include="keepAliveRouteNames">
          <component :is="Component" :key="route.name" />
        </keep-alive>
      </router-view>
      <!-- 底部导航 -->
      <TabBar v-if="tokenReady" />
    </div>
  </VanConfigProvider>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, reactive } from 'vue';
import { clearWxConfig } from '@/utils/auth';
import TabBar from '@/components/TabBar.vue';
import { useRouteCacheStore } from './stores/routeCache';
import { ConfigProvider as VanConfigProvider } from 'vant';
import useAppStore from './stores/app';
import { useAuthInit } from '@/hooks/use-auth-init';
import { useWxConfigStore } from '@/stores/wxConfig';

// 只保留你需要的主题变量
const themeVars = reactive({
  buttonPrimaryBackground: 'linear-gradient( 300deg, #A637FF 0%, #6186FF 100%)',
  dialogConfirmButtonTextColor: '#875AFF',
  primaryColor: '#875AFF',
});

// 使用主题 Store，支持跟随系统和手动切换
const appStore = useAppStore();

const { setFirstUrl } = useWxConfigStore();
setFirstUrl(window.location.href);

const routeCacheStore = useRouteCacheStore();

// 使用认证初始化 composable
const { tokenReady, initAuth } = useAuthInit();

// 计算需要缓存的路由名称
const keepAliveRouteNames = computed(() => {
  return routeCacheStore.routeCaches as string[];
});

/**
 * 组件挂载时初始化认证流程
 */
onMounted(() => {
  initAuth();
});

/**
 * 组件卸载前清理微信配置
 */
onBeforeUnmount(() => {
  clearWxConfig();
});
</script>

<style>
#app {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  overscroll-behavior: none; /* 禁止过度滚动 */
  -webkit-overscroll-behavior: none;
}
div {
  overscroll-behavior: none; /* 禁止过度滚动 */
  -webkit-overscroll-behavior: none;
}
.app-scroll {
  width: 100%;
  height: 100vh;
  background-color: #f5f5f5;
  overflow: auto;
  overscroll-behavior: none; /* 禁止过度滚动 */
  -webkit-overscroll-behavior: none;
}
</style>
